<template>
    <div class="main-box">
        <div class="main-title flex-y-center flex-start">
            <div class="black font34 bold">Ta添加的</div>
        </div>
        <div class="flex flex-between flex-y-center mb-40">
            <div class="name-label">员工:</div>
            <div class="name-list flex flex-start flex-y-center" @click="showEmployeePopup">
                <div class="flex flex-start" v-if="threeEmployeeList.length != 0">
                    <div v-for="item in threeEmployeeList" :key="item.id" class="name-info flex flex-between flex-y-center">
                        <img class="head-img" :src="item.avatar" alt="" />
                        <div class="name">{{ item.name }}</div>
                    </div>
                </div>
                <div class="txt flex-1" v-else>暂无</div>
                <van-icon class="arrow" name="arrow" color="#a0acb5" />
            </div>
        </div>
        <div class="flex flex-between flex-y-center">
            <div class="black font34 bold">个人标签</div>
            <div class="add-tag-btn" @click="showPersonPopup">
                &nbsp;
                <van-icon name="plus" />&nbsp;添加&nbsp;&nbsp;
            </div>
        </div>
        <div class="personal mb-30" v-if="ownTagList.length != 0">
            <div class="tags" v-for="(item, index) in ownTagList" :key="index">
                {{ item.name }}
            </div>
        </div>
        <div class="txt-no" v-else>暂无</div>

        <div class="flex flex-start flex-y-center">
            <div class="black font34 bold">企业标签</div>
        </div>
        <div class="firm mb-50" v-if="companyTagList.length != 0">
            <div class="firm-tags" v-for="(item, index) in companyTagList" :key="index">
                {{ item }}
            </div>
        </div>
        <div class="txt-no" v-else>暂无</div>

        <div class="flex flex-between flex-y-center mb-50">
            <div class="black font34 bold">顾客动态</div>
            <div class="select-tag-btn" @click="showEventPopup">
                &nbsp;
                <van-icon name="filter-o" />&nbsp;筛选事件&nbsp;&nbsp;
            </div>
        </div>
        <van-list v-model="eventLoading" :finished="eventFinished" finished-text="没有更多了" @load="loadCustDynamic" :offset="20" :immediate-check="false">
            <div v-for="item in dynamicList" :key="item.id" class="flex flex-between flex-x-center mb-30">
                <div class="line">
                    <div class="line-circle"></div>
                </div>
                <div>
                    <div class="dynamic-box flex-1 flex flex-col flex-start">
                        <div class="dynamic-title">
                            {{ item.date }}&nbsp;{{ item.week }}
                        </div>
                        <div class="dynamic-time">{{ item.time }}</div>
                        <div class="dynamic-info">
                            <div class="flex flex-y-center mb-20">
                                <img class="info-img" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/follow.png" />
                                <div class="info-tit">{{ item.typeName }}</div>
                            </div>
                            <div class="info-txt mb-20">{{ item.content }}</div>
                            <div class="flex flex-y-center mb-20">
                                <div class="info-txt">跟进人:</div>
                                <div class="flex flex-y-center">
                                    <img class="info-img" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png" />
                                    <div class="info-tit">{{ item.creatorName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
        <!-- 添加个人标签弹窗 -->
        <van-popup v-model="showPerson" round position="bottom" get-container="#app" closeable>
            <div class="popup-container">
                <div class="title">添加个人标签</div>
                <van-search v-model="searchValue" placeholder="请输入标签名称" :disabled="tagListLoading" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png" />
                <div class="operator">
                    <div v-if="!isCreating" class="add">
                        <van-button size="mini" plain round type="info" color="#798A94" @click="createTag" :loading="tagListLoading">
                            &nbsp;
                            <van-icon name="plus" />&nbsp;添加&nbsp;&nbsp;
                        </van-button>
                    </div>
                    <template v-else>
                        <van-field v-model="value" placeholder="请输入标签">
                            <template #button>
                                <van-button round size="mini" @click="cancelPerson" class="operator-button cancel" :loading="tagCreateLoading || tagListLoading">取消</van-button>
                                <van-button round size="mini" @click="confirmPerson" color="#333F48" class="operator-button" :loading="tagCreateLoading || tagListLoading">确定</van-button>
                            </template>
                        </van-field>
                    </template>
                </div>
                <van-loading v-if="tagListLoading"></van-loading>
                <div class="tag-list" v-else>
                    <van-tag v-for="(item, index) in searchTagList" :key="index" :color="item.color" :text-color="item.textColor" :style="{ borderColor: item.borderColor }" class="tags tag-item" @click="tagClick(item)">
                        {{ item.name }}
                        <div class="delete flex flex-x-center flex-y-center" @click.stop="deleteTag(item, index)">
                            <van-icon size="10px" color="#fff" name="cross" />
                        </div>
                    </van-tag>
                </div>
                <van-button round @click="savePerson" color="#333F48" class="save-button" block :loading="tagSaveLoading || tagListLoading">保存</van-button>
            </div>
        </van-popup>
        <!-- 筛选事件弹窗 -->
        <van-popup v-model="showEvent" round position="bottom" get-container="#app" closeable>
            <div class="popup-container">
                <div class="title mb-40">选择事件</div>
                <div class="event-list-box">
                    <div v-for="item, index in eventList" :key="index" class="event-list">
                        <div class="event-tit">{{ item.name }}</div>
                        <div class="list-box">
                            <van-tag v-for="oItem, indexs in item.children" :key="indexs" :color="activeEventIdList.includes(oItem.id)
                                ? TAG_ACTIVE_STYLE.color
                                : TAG_NORMAL_STYLE.color
                                " :text-color="activeEventIdList.includes(oItem.id)
                                    ? TAG_ACTIVE_STYLE.textColor
                                    : TAG_NORMAL_STYLE.textColor
                                    " class="events" :style="{
                                        borderColor: activeEventIdList.includes(oItem.id)
                                            ? 'transparent'
                                            : '#A0ACB5'
                                    }" @click="eventTagClick(oItem.id)">
                                {{ oItem.name }}
                            </van-tag>
                        </div>
                    </div>
                </div>
                <div class="event-btn-box flex flex-y-center flex-between">
                    <van-button class="event-btn" style="color:#A0ACB5" round @click="resetEvent" block> 重置 </van-button>
                    <van-button class="event-btn " round @click="confirmEvent" color="#333F48" block>筛选
                    </van-button>
                </div>

            </div>
        </van-popup>
        <!-- 员工弹窗 -->
        <van-popup v-model="showEmployee" round position="bottom" get-container="#app" closeable>
            <div class="popup-container">
                <div class="title">员工</div>
                <div class="title mb-20">Ta添加的员工（{{ employeeList.length }}）</div>
                <van-list :finished="true" finished-text="没有更多了" :offset="20" :immediate-check="false">
                    <div v-for="item in employeeList" :key="item.id" class="employee-list mb-20">
                        <img class="head-img-large" :src="item.avatar" alt="" />
                        <div class="info-box">
                            <div class="head">
                                <div class="name">{{ item.name }}</div>
                                <div class="address">{{ item.storeName }}</div>
                            </div>
                            <div class="time">添加时间：{{ item.bindDate }}</div>
                            <div class="time">最近沟通：</div>
                        </div>
                    </div>
                </van-list>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import _ from "lodash";
    import { Popup, Cell, Field, Tag, Search, CellGroup, Dialog, Toast } from "vant";
    import { TAG_NORMAL_STYLE, TAG_ACTIVE_STYLE } from "./constants";

    export default {
        components: {
            [CellGroup.name]: CellGroup,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Tag.name]: Tag,
        },
        props: {
            custId: String,
            mobile: String,
        },
        data() {
            return {
                TAG_NORMAL_STYLE,
                TAG_ACTIVE_STYLE,
                searchValue: "",
                value: "",
                showPerson: false, //添加个人标签弹窗
                showEvent: false, //筛选弹窗
                tagList: [],
                isCreating: false, //添加个人标签
                loading: true, //list
                finished: false, //list
                eventList: [],
                employeeList: [],
                showEmployee: false,
                companyTagList: [],
                ownTagList: [],
                activeTagIdList: [],
                tagCreateLoading: false,
                tagSaveLoading: false,
                tagListLoading: false,
                dynamicList: [],
                activeEventIdList: [],
                eventPage: 1,
                eventFinished: false,
                eventLoading: false,
            };
        },
        computed: {
            threeEmployeeList() {
                return this.employeeList.length <= 3
                    ? this.employeeList
                    : this.employeeList.slice(0, 3);
            },
            searchTagList() {
                if (this.searchValue) {
                    return this.tagList.filter((item) =>
                        item.name.includes(this.searchValue)
                    );
                }
                return this.tagList;
            },
        },
        mounted() {
            this.loadEmployeeList();
            this.loadContactTag();
            this.loadContactTagAll();
            this.loadCustDynamic();
            this.loadCustDynamicType();
        },
        methods: {
            loadEmployeeList() {
                request({
                    url: `/contactEmployee/getEmployeeList?contactId=${this.custId}`,
                    method: "get",
                })
                    .then((res) => {
                        this.employeeList = res.data;
                    })
                    .catch((error) => {
                        this.employeeList = [];
                        Toast({ position: 'top', message: error ?? '' })

                    });
            },
            loadContactTag() {
                request({
                    url: `/contactEmployee/getContactTag`,
                    method: "post",
                    data: { contactId: this.custId, phone: this.mobile },
                })
                    .then((res) => {
                        if (res.data) {
                            this.ownTagList = res.data.mySelfTag;
                            this.companyTagList = res.data.corpTag;
                        } else throw false;
                    })
                    .catch((error) => {
                        this.ownTagList = [];
                        this.companyTagList = [];
                        Toast({ position: 'top', message: error ?? '' })

                    });
            },
            loadContactTagAll() {
                this.tagListLoading = true;
                request({
                    url: `/contactEmployee/getAllContactEmployeeTag?contactId=${this.custId}`,
                    method: "get",
                })
                    .then((res) => {
                        if (res.data) {
                            this.tagList = res.data
                                .filter((item) => item.status === 0)
                                .map((item) => {
                                    let tagStyle = TAG_NORMAL_STYLE;
                                    let borderColor = '#A0ACB5'
                                    if (this.activeTagIdList.length) {
                                        if (this.activeTagIdList.includes(item.id)) {
                                            tagStyle = TAG_ACTIVE_STYLE;
                                            borderColor = 'transparent'
                                            item.showStatus = 1;
                                        } else {
                                            item.showStatus = 0;
                                        }
                                    } else if (item.showStatus === 1) {
                                        tagStyle = TAG_ACTIVE_STYLE;
                                        borderColor = 'transparent'
                                    }
                                    return { ...item, ...tagStyle, borderColor };
                                });
                            console.log(this.tagList);
                        } else throw false;
                    })
                    .catch((error) => {
                        this.tagList = [];
                        Toast({ position: 'top', message: error ?? '' })
                    })
                    .finally(() => {
                        this.tagListLoading = false;
                    });
            },
            // 个人标签相关
            showPersonPopup() {
                this.activeTagIdList = [];
                this.loadContactTagAll();
                this.showPerson = true;
            },
            // 显示新建
            createTag() {
                this.isCreating = true;
            },
            // 哪些是选中标签
            updateActiveTagIdList() {
                this.activeTagIdList = this.tagList
                    .filter((item) => item.showStatus === 1)
                    .map((item) => item.id);
            },
            // 新增标签项
            confirmPerson() {
                if (!this.value) return;
                this.tagCreateLoading = true;
                request({
                    url: `/contactEmployee/saveContactTag`,
                    method: "post",
                    data: {
                        contactId: this.custId,
                        // employeeId: 184,
                        name: this.value,
                    },
                })
                    .then(() => {
                        this.updateActiveTagIdList();
                        this.loadContactTagAll();
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
                    .finally(() => {
                        this.cancelPerson();
                        this.tagCreateLoading = false;
                    });
            },
            // 保存个人标签
            savePerson() {
                this.tagSaveLoading = true;
                request({
                    url: `/contactEmployee/updateContactTag`,
                    method: "post",
                    data: this.tagList,
                })
                    .then(() => {
                        this.showPerson = false;
                    })
                    .catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
                    .finally(() => {
                        this.loadContactTag();
                        this.tagSaveLoading = false;
                    });
            },
            // 关闭新建
            cancelPerson() {
                this.isCreating = false;
                this.value = "";
            },
            // 点击标签选中/取消
            tagClick(tagItem) {
                let item = this.tagList.find((item) => item.id === tagItem.id);
                const isActive = item.showStatus === 1;
                if (isActive) {
                    item.color = TAG_NORMAL_STYLE.color;
                    item.textColor = TAG_NORMAL_STYLE.textColor;
                    item.borderColor = '#A0ACB5';
                    item.showStatus = 0;
                } else {
                    item.color = TAG_ACTIVE_STYLE.color;
                    item.textColor = TAG_ACTIVE_STYLE.textColor;
                    item.borderColor = 'transparent';
                    item.showStatus = 1;
                }
            },
            // 筛选事件相关
            showEventPopup() {
                this.showEvent = true;
            },
            showEmployeePopup() {
                this.showEmployee = true;
            },
            // 删除标签
            deleteTag(item, index) {
                Dialog.confirm({
                    title: "删除标签",
                    message: `标签已绑定客户，是否同时删除客户绑定的标签?`,
                    confirmButtonColor: '#3fb8e2'
                }).then(() => {
                    request({
                        url: `/contactEmployee/delContactTag`,
                        method: "post",
                        data: {
                            contactId: this.custId,
                            id: item.id,
                        },
                    })
                        .then(() => {
                            this.tagList.splice(index, 1);
                        })
                        .catch((error) => {
                            Toast({ position: 'top', message: error ?? '' })
                        })
                        .finally(() => {
                            this.updateActiveTagIdList();
                            this.loadContactTagAll();
                        });
                }).catch(() => {
                    // on cancel
                })
            },
            // 顾客动态
            loadCustDynamic() {
                const type = this.activeEventIdList.join(",");
                request({
                    url: `/custinfo/dynamic?mobile=${this.mobile}&page=${this.eventPage}&type=${type}`,
                    method: "get",
                })
                    .then((res) => {
                        if (res.data && res.data.length > 0) {
                            this.dynamicList =
                                this.eventPage === 1
                                    ? res.data
                                    : this.dynamicList.concat(res.data);
                            this.eventPage += 1;
                        } else {
                            if (this.eventPage === 1) {
                                this.dynamicList = []
                            }
                            this.eventFinished = true;
                        }
                    })
                    .catch(() => {
                        this.eventPage = 1;
                        this.dynamicList = [];
                    })
                    .finally(() => {
                        this.eventLoading = false;
                    });
            },
            // 动态可选类型
            loadCustDynamicType() {
                request({
                    url: `/custinfo/dynamicType`,
                    method: "get",
                })
                    .then((res) => {
                        this.eventList = res.data;
                    })
                    .catch(() => {
                        this.eventList = [];
                    });
            },
            eventTagClick(eventId) {
                const index = this.activeEventIdList.findIndex((id) => id === eventId);
                if (index > -1) {
                    this.activeEventIdList.splice(index, 1);
                } else {
                    this.activeEventIdList.push(eventId);
                }
            },
            resetEvent() {
                this.activeEventIdList = [];
            },
            confirmEvent() {
                this.eventPage = 1;
                this.showEvent = false;
                this.eventFinished = false;
                this.loadCustDynamic();
            },
        },
    };
</script>
<style lang="less" scoped>
    .txt {
        color: #a0acb5;
        font-size: 30px;
    }

    .txt-no {
        color: #a0acb5;
        font-size: 30px;
        margin: 50px 0;
    }

    .mt-20 {
        margin-top: 20px;
    }

    .mr-10 {
        margin-right: 10px;
    }

    :deep(.van-loading) {
        text-align: center;
    }

    .name-list .van-cell {
        border: none;
        border-bottom: 1px solid #000;
    }

    .nomore {
        width: 120px;
        height: 33px;
        font-size: 24px;
        font-weight: 400;
        color: #a0acb5;
        line-height: 33px;
        text-align: center;
        margin: 40px auto;
    }

    /* ----- */
    .main-box {
        width: 100%;
        height: 100%;
        background-color: #fff;
        /* padding: 0 30px 50px 30px; */
        margin-top: 40px;
    }

    .name-label {
        width: 123px;
        height: 120px;
        font-size: 30px;
        color: #35434c;
        line-height: 120px;
    }

    .name-list {
        flex: 1;
        height: 120px;
        border-bottom: 1px solid #d7d7d7;
    }

    .name-list {
        // padding-top: 5px;
        position: relative;
    }

    .name-info {
        width: 170px;
        margin-right: 15px;
    }

    .head-img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
    }

    .name {
        width: 100px;
        height: 42px;
        font-size: 30px;
        color: #35434c;
        line-height: 42px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .arrow {
        font-size: 34px;
        height: 28px;
    }

    .add-tag-btn {
        width: 118px;
        height: 50px;
        border-radius: 25px;
        background-color: #2fd0d5;
        color: #fff;
        font-size: 24px;
        line-height: 50px;

        :deep(.van-icon) {
            font-size: 24px !important;
            font-weight: 700px !important;
        }
    }

    .select-tag-btn {
        width: 168px;
        height: 50px;
        background: #2fd0d5;
        border-radius: 25px;
        color: #fff;
        font-size: 24px;
        line-height: 50px;

        :deep(.van-icon) {
            font-size: 24px !important;
            font-weight: 700px !important;
        }
    }

    .personal {
        border-bottom: 1px solid #d7d7d7;
        padding: 30px 17px 20px 0;
        display: flex;
        flex-wrap: wrap;
    }

    .tags {
        position: relative;
        min-width: 64px;
        height: 60px;
        line-height: 60px;
        background: #3fb8e2;
        border-radius: 4px;
        padding: 0 30px;
        font-size: 26px;
        margin: 10px;
        color: #fff;
        object-fit: cover;
        display: flex;
        justify-content: center;
        // &:nth-last-of-type(-n + 5) {
        flex-grow: 0;
        border: 1px solid transparent;

        // }
        .delete {
            width: 34px;
            height: 34px;
            background: #a0acb5;
            border-radius: 50%;
            position: absolute;
            right: -17px;
            top: -17px;
        }
    }

    .firm {
        padding: 30px 17px 20px 0;
        display: flex;
        flex-wrap: wrap;
    }

    .firm-tags {
        position: relative;
        min-width: 64px;
        height: 60px;
        line-height: 60px;
        background: #4375c9;
        border-radius: 4px;
        padding: 0 30px;
        font-size: 26px;
        margin: 10px;
        color: #fff;
        object-fit: cover;
        display: flex;
        justify-content: center;
        flex-grow: 0;

        // &:nth-last-of-type(-n + 5) {
        //   flex-grow: 0;
        // }
        .delete {
            width: 34px;
            height: 34px;
            background: #a0acb5;
            border-radius: 50%;
            position: absolute;
            right: -17px;
            top: -17px;
        }
    }

    .line {
        background: #333f48;
        width: 1px;
        position: relative;
        margin-top: 15px;
    }

    .line-circle {
        width: 15px;
        height: 15px;
        background: #333f48;
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -7.5px;
    }

    .dynamic-box {
        margin-left: 30px;
    }

    .dynamic-title {
        font-size: 30px;
        font-weight: 400;
        color: #35434c;
        line-height: 42px;
        margin-bottom: 10px;
    }

    .dynamic-time {
        margin-bottom: 30px;
        font-size: 26px;
        font-weight: 400;
        color: #798a94;
        line-height: 37px;
    }

    .dynamic-info {
        width: 644px;
        background: #fafafe;
        border-radius: 16px;
        border: 1px solid #798a94;
        padding: 30px 20px;

        .info-img {
            width: 40px;
            height: 40px;
        }

        .info-tit {
            font-size: 28px;
            font-weight: 400;
            color: #35434c;
            margin-left: 10px;
        }

        .info-txt {
            font-size: 28px;
            font-weight: 400;
            color: #798a94;
            line-height: 40px;
            margin-right: 30px;
        }
    }

    // 个人标签弹窗样式
    .popup-container {
        max-height: 852px;
        margin: 0 30px;

        .title {
            margin-top: 32px;
            font-size: 34px;
        }

        .save-button {
            margin: 80px auto;
        }

        .event-btn-box {
            margin: 80px 80px;
            // padding: 70px 0;
        }

        .event-btn {
            width: 250px;
        }

        :deep(.van-search) {
            padding: 20px 0;
        }

        :deep(.van-field__control) {
            font-size: 28px !important;
        }

        :deep(.van-field__left-icon) {
            color: #c8c9cc !important;
            padding: 8px 20px 0 0 !important;
            margin-right: 0 !important;
        }

        .operator {
            .add {
                display: flex;
                justify-content: flex-end;
            }

            .cancel {
                margin-right: 20px;
            }

            .operator-button {
                width: 88px;
                font-size: 24px;
            }

            :deep(.van-field__control) {
                padding: 10px 15px;
                background-color: #f3f5f6;
                font-size: 28px;
                border-radius: 6px;
            }

            :deep(.van-button--default) {
                color: #a0acb5;
            }

            :deep(.van-cell) {
                padding: 0;
            }
        }

        .tag-list {
            padding: 30px 25px 20px 0;
            display: flex;
            flex-wrap: wrap;
            max-height: 400px;
            overflow-y: auto;

            .tag-item {
                margin: 15px;
            }
        }

        .event-list-box {
            max-height: 580px;
            overflow-y: auto;
        }

        .event-list {
            padding: 30px 25px 20px 0;
            max-height: 400px;

            .event-tit {
                font-size: 28px;
                font-weight: 400;
                color: #a0acb5;
                line-height: 40px;
                margin-bottom: 25px;
            }

            .events {
                width: 212px;
                height: 60px;
                background: #2fd0d5;
                border-radius: 4px;
                line-height: 60px;
                padding: 0 30px;
                font-size: 26px;
                margin: 10px;
                color: #fff;
                border: 1px solid transparent;
            }
        }

        .employee-list {
            display: flex;
            align-items: center;
            padding: 30px 20px 34px;
            width: 690px;
            height: 188px;
            background: #fafafe;
            border-radius: 6px;

            .head-img-large {
                width: 100px;
                height: 100px;
                border-radius: 50%;
            }

            .info-box {
                display: flex;
                color: #35434c;
                flex-direction: column;
                margin-left: 30px;
                overflow: hidden;

                .head {
                    display: flex;
                    margin-bottom: 10px;

                    .name {
                        font-size: 30px;
                        font-weight: bold;
                        flex-shrink: 1;
                    }

                    .address {
                        font-size: 24px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }

                .time {
                    font-size: 24px;
                    color: #a0acb5;
                    margin-bottom: 10px;
                }
            }
        }
    }

    :deep(.van-search__content) {
        background: #f3f5f6;
    }

    :deep(.popup-container .van-button--default) {
        border-color: #a0acb5;
    }
</style>
